var bootbox = require('./plugins/bootbox/bootbox.min');
require('./plugins/morrisjs/morris.min');

export class WdEventCommon {
	defaultOptions() {
		return {
			show: false,
			recurrenceMonitoring: false,
			yearServer : 0,
			yearDatabase : 0,
			yearCanEdit : false,
			lockInterval: 2000,
			guiltLevelTypes : {
				traffic : 1,
				other : 2,
			},
			sheriffDeviceInfo : {
				geolocationEnabled: false,
				geolocationSuccess: false,
				photoTaken: false,
				deviceType: "",
				androidApp: false,
			},
			private : {
				isDirty: false,
				lockPing: null,
			},
		};
	}
	
	constructor() {
		var options = $('#js-opts').data('wdEventCommon'),
			$eventForm = $('#eventForm'),
			$wdForm = $('#wrongDoingsForm');
		this.$options = $.extend({}, this.defaultOptions(), options || {});
		this._id = null;
		this._type = 'wrongDoings';
		
		if ($wdForm.length) {
			$wdForm.validator();
		} else if ($eventForm.length) {
			$eventForm.validator();
		}

		if (this.checkYearChange()) {
			this.handleButtons();
			this.initPanels();
			if (!this.$options.show) {
				this.activateIsepButtons();
				this.logDeviceType();
			}
		}
	}

	//=====================================================================
	// Public
	//=====================================================================

	isDirty () {
		return this.$options.private.isDirty;
	}
	resetDirty () {
		this.$options.private.isDirty = false;
	}
	
	setType (type) {
		this._type = type;
	}
	setId (id) {
		this._id = id;
		if (this._id) {
			let app = this;
			app.$options.private.lockPing = window.setInterval(function () {
				app.pingLock();
			}, app.$options.lockInterval);
		}
	}

	//=====================================================================
	// RZ
	//=====================================================================

	updateRzWhisperer ($select) {
		var app = this,
			$options = $select.find('option'),
			filesController = window.$filesControls,
			rzs = filesController.getRZ().slice(),
			selected = false;
		$options.each(function (i, opt) {
			if (opt.selected) {
				var index = rzs.indexOf(rzs.find(function (obj) { return obj.rz === opt.value; }));
				if (index >= 0) {
					rzs.splice(index, 1);
				}
			} else {
				$(opt).remove();
				selected = true;
			}
		});
		$.each(rzs, function(i, e) {
			var newOption = new Option(e.rz, e.rz, false, false);
			$select.append(newOption);
		});
	}

	loadRzCountry ($select) {
		var filesController = window.$filesControls,
			rzs = filesController.getRZ();
		if ($select.val()) {
			$.each(rzs, function (i, rz) {
				if ((rz.rz === $select.val()) && rz.country) {
					$('input#country').val(rz.country);
					return false;
				}
			});
		}
	}

	//=====================================================================
	// Recurrence Monitoring
	//=====================================================================

	setupRecurrenceMonitoringFields() {
		var app = this;

		if (app.$options.recurrenceMonitoring) {
			$('#recurrenceMonitoringNumberRow').removeClass('hidden');
			$('button.js-upload-registry-isep').removeClass('hidden');
		} else {
			$('#recurrenceMonitoringNumberRow').addClass('hidden');
			$('button.js-upload-registry-isep').addClass('hidden');
		}
	}

	editRecurrenceMonitoringNumber () {
		$("#recurrenceMonitoringNumberText").addClass('hidden');
		$("#recurrenceMonitoringNumber").removeClass('hidden');
	}

	editRecurrenceMonitoringTime () {
		var $numberText = $("#recurrenceMonitoringNumberText");
		$("#updateRmdFilledAt").val('true');
		$("#updateRmdFilledAtValue").removeClass('hidden');
		$numberText.find('span.isep-write-time').addClass('hidden');
		$numberText.find('span.js-recurrence-monitoring-update-time').addClass('hidden');
		$numberText.find('span.js-edit-recurrence-monitoring-number').addClass('hidden');
	}

	//=====================================================================
	// UI
	//=====================================================================

	togglePanelBody ($header)
	{
		var $body = $header.parent().find('.panel-body');
		if ($header.hasClass('hiding-hidden'))
		{
			$body.slideDown({
				/*duration: 200,*/
				done: function () {
					$body.removeClass('hiding-body-hidden');
					$body.removeClass('hiding-body-hiding');
				},
				step: function () {
					$body.addClass('hiding-body-hiding');
				},
			});
			$header.removeClass('hiding-hidden');
		}
		else
		{
			$body.slideUp({
				/*duration: 200,*/
				done: function () {
					$body.addClass('hiding-body-hidden');
					$body.removeClass('hiding-body-hiding');
				},
				step: function () {
					$body.addClass('hiding-body-hiding');
				},
			});
			$header.addClass('hiding-hidden');
		}
	}

	initPanels () {
		var app = this,
			first = true;
		$('.panel-heading.hiding').each(function (i, el) {
			if (first)
			{
				var $parent = $(el).parent();
				if (!$parent.hasClass('hidden') && !$parent.hasClass('js-tpl'))
				{
					first = false;
				}
			}
			else
			{
				app.togglePanelBody($(el));
			}
		});
	}

	removeBlock ($button) {
		if (!$button.hasClass('disabled')) {
			var panelClass = $button.data('panelClass'),
				$panel = $button.closest('.panel.' + panelClass),
				$dc = window.$desperadoController;

			if ($panel.hasClass('type-a_desperado') && $dc)
			{
				$dc.confirmDesperadoRemoval($panel, null, null);
			}
			else
			{
				$panel.remove();

				if ($panel.hasClass('wd-indian'))
				{
					$indians.setWrongDoingStateByIndians();
				}
			}
		}
	}

	stagecoachTypeChanged ($li) {
		var value = $li.data('value');

		$('.horseOrStagecoachType').attr('disabled', 'disabled');

		$('#stagecoachTypeType').val(value).trigger('change');
		$('#horseOrStagecoachType-' + value).removeAttr('disabled')
	}

	setTimeNow() {
		let now = new Date(),
			date = now.getDate()  + "." + (now.getMonth()+1) + "." + now.getFullYear(),
			time = now.getHours() + ":" + Morris.pad2(now.getMinutes());

		$('#time_date').val(date);
		$('#time_time').val(time);
	}


	//=====================================================================
	// Guilt levels
	//=====================================================================

	loadGuiltLevelData ($select) {
		var app = this,
			guiltTypes = app.$options.guiltLevelTypes,
			wizardStep = app.$options.wizardStep;
		$.ajax({
			url: route('wrongDoings.getGuiltLevelDetails', {}),
			dataType: 'json',
			method: 'post',
			data: {
				id: $select.val()
			},
			success: function (guiltLevel) {
				if (guiltLevel && ('id' in guiltLevel))
				{
					var body = (guiltLevel.reward_points_count > 0) ? guiltLevel.reward_points_count : $Lang.common.no,
						priceRange = guiltLevel.priceRangeString;
					$('#wrongDoingParagrafA').text(guiltLevel.paragraf_a);
					$('#wrongDoingOdstavecA').text(guiltLevel.odstavec_a);
					$('#wrongDoingPismenoA').text(guiltLevel.pismeno_a);
					$('#wrongDoingParagrafB').text(guiltLevel.paragraf_b);
					$('#wrongDoingOdstavecB').text(guiltLevel.odstavec_b);
					$('#wrongDoingPismenoB').text(guiltLevel.pismeno_b);
					$('#wrongDoingBod').text(guiltLevel.bod_b);
					$('#bodyPocet').text(body);
					$('#bodyPocetSm').text(body);
					$('#priceRange').html(priceRange);
					$('#priceRangeSm').html(priceRange);
					$('#wrongDoingLaw').text(guiltLevel.law);

					var displayVehicle = false;
					if (guiltLevel.type == guiltTypes.traffic)
					{
						$('.wrongDoingSpecs.spec_law').addClass('hidden');
						$('.wrongDoingSpecs.spec_a').removeClass('hidden');
						if (!window.$wrongDoing || !window.$wrongDoing.wizardOnDescription()) {
							$('.panel.wd-stagecoach').removeClass('hidden');
						}
						displayVehicle = true;
					}
					else
					{
						displayVehicle = false;
						$('.wrongDoingSpecs.spec_law').removeClass('hidden');
						$('.wrongDoingSpecs.spec_a').addClass('hidden');
						if (guiltLevel.display_vehicle) {
							if (!window.$wrongDoing || !window.$wrongDoing.wizardOnDescription()) {
								$('.panel.wd-stagecoach').removeClass('hidden');
							}
							displayVehicle = true;
							$('#stagecoachTypeType').removeAttr('disabled');
						} else {
							$('.panel.wd-stagecoach').addClass('hidden');
							$('#stagecoachTypeType').attr('disabled', 'disabled');
						}
					}
					app.$options.recurrenceMonitoring = guiltLevel.recurrence_monitoring;
					app.setupRecurrenceMonitoringFields();

					if (guiltLevel.description && !$('#guiltLevelNote').val())
					{
						$('#guiltLevelNote').val(guiltLevel.description).trigger('change');
					}
					window.$wrongDoing.wizardUpdateButtons(displayVehicle);
				}
			},
			error: function (a, b) {
				console.log('error', a);
			},
		});
	}

	updateGuiltLevelDate ($dateInput) {
		var date = $dateInput.val(),
			$select = $('#guiltLevelId');

		$select.data('guiltDate', date );
	}

	//=====================================================================

	activateIsepButtons () {
		var app = this,
			$desperados = $('.panel.wd-desperado');
		if (window.$registry) {
			$desperados.each(function (i, panel) {
				window.$registry.checkIsepLoadButtonEnabled($(panel));
			});
		}
	}

	//=====================================================================
	// Year change
	//=====================================================================


	checkYearChange () {
		var app = this,
			options = app.$options;
		if (options.yearServer != options.yearDatabase)
		{
			var bbOptions = {
				'title': "Detekována změna roku",
				'message': "Server tvrdí, že je rok "
					+ options.yearServer
					+ ", zatímco Violeta si myslí, že máme rok "
					+ options.yearDatabase
					+ ".<br>",
				buttons: null,
				callback: null,
			};

			if (options.yearCanEdit)
			{
				bbOptions.message += "<strong>Potvrďte, prosím, změnu roku.</strong>";
				bbOptions.buttons = {
					confirm: {
						label: "Ano, píše se rok " + options.yearServer,
						className: 'btn-success'
					},
					cancel: {
						label: "Ne, jedná se o chybu",
						className: 'btn-danger'
					}
				};
				bbOptions.callback = function (result) {
					if (result)
					{
						app.setNewYearValue();
					}
					else
					{
						bootbox.alert({
							'message':"Kontaktujte správce.",
							'callback': function () {
								app.backToList();
							}
						});
					}
				}
			}
			else
			{
				bbOptions.message += "<strong>Informujte svého nadřízeného.</strong>";
				bbOptions.buttons = {
					cancel: {
						label: $Lang.common.ok,
						className: 'btn-info'
					},
					confirm: {
						label: "",
						className: 'hidden'
					},
				};
				bbOptions.callback = function () {
					app.backToList();
				}
			}

			bootbox.confirm(bbOptions);

			return false;
		}
		return true;
	}

	setNewYearValue () {
		var app = this,
			url = route('system.updateYear', {}),
			lang = $Lang.wrongDoings;
		if (url) {
			$.ajax({
				url: url,
				dataType: 'json',
				method: 'post',
				success: function (response) {
					bootbox.alert({
						'message': lang.yearSet,
						'callback': function () {
							window.location.reload();
						}
					});
				},
				error: function (e) {
					bootbox.alert({
						'message': lang.saveFailedAjax,
						'callback': function () {
							app.backToList();
						}
					});
				},
			});
		}
		else
		{
			bootbox.alert({
				'message': lang.saveFailedAjax,
				'callback': function () {
					app.backToList();
				}
			});
		}
	}

	backToList () {
		//Redirect to the list
		window.location.href = window.location.href
			.replace("/create", "")
			.replace("/edit", "");
	}

	//=====================================================================
	// Unique access lock
	//=====================================================================
	
	pingLock() {
		var app = this;

		$.ajax({
			url: route(app._type + '.pingLock', {'id': app._id}),
			dataType: 'json',
			method: 'post',
			data: {
			},
			success(r) {
				if (!r)
				{
					bootbox.alert({
						title: "Chyba",
						message: "Záznam edituje jiný uživatel",
						callback() {
							window.location.href = window.location.href.replace("/edit", "");
						},
					});
					clearInterval(app.$options.private.lockPing);
				}
			},
			error(e) {
				console.log('Lock error: ', e);
			},
		});
	}

	
	//=====================================================================
	// Device info
	//=====================================================================

	logDeviceType () {
		var app = this;
		window.setTimeout(function () {
			if (typeof $mobileDetector !== 'undefined') {
				app.setSheriffDeviceInfo('deviceType', $mobileDetector.getDeviceTypeString());
			}
		}, 500);
	}

	setSheriffDeviceInfo (property, value) {
		if (property in this.$options.sheriffDeviceInfo) {
			this.$options.sheriffDeviceInfo[property] = value;
			$('#sheriff_device_info').val(JSON.stringify(this.$options.sheriffDeviceInfo));
		} else {
			console.error(property + " not in sheriffDeviceInfo");
		}
	}


	//=====================================================================
	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		$document.on('click touch', '.panel-heading.hiding', function () {
			app.togglePanelBody($(this));
		});

		if (!app.$options.show) {
			//Stagecoach
			$document.on('select2:opening', '#licensePlate', function () {
				app.updateRzWhisperer($(this));
			});
			$document.on('select2:select change', '#licensePlate', function () {
				app.loadRzCountry($(this));
			});

			//Recurrence monitoring
			$document.on('change', '.wd-indians #state', function () {
				app.setupRecurrenceMonitoringFields();
			});
			$document.on('click', '.js-edit-recurrence-monitoring-number', function () {
				app.editRecurrenceMonitoringNumber($(this));
			});
			$document.on('click', '.js-recurrence-monitoring-update-time', function () {
				app.editRecurrenceMonitoringTime($(this));
			});

			//UI
			$document.on('click', '.js-remove-block', function (e) {
				e.preventDefault();
				app.removeBlock($(this));
			});
			$document.on('click', '.stagecoach-type-tabs > li', function () {
				app.stagecoachTypeChanged($(this));
			});
			$document.on('change', 'input, select, checkbox, textarea', function () {
				app.$options.private.isDirty = true;
				$(".alert-success").remove();
			});
			$document.on('click', '.js-set-now', function() {
				app.setTimeNow();
			});
			
			//Guilt levels
			$document.on('change', "select[name='guilt_level_id']", function () {
				app.loadGuiltLevelData($(this));
			});
			$document.on('change', '#time_date', function () {
				app.updateGuiltLevelDate($(this));
			});

			//ISEP
			$document.on('keyup', ".wd-desperado input[id^='desperado-placeOfOrigin-']", function (e) {
				if (window.$registry) {
					window.$registry.checkIsepLoadButtonEnabled($(this).closest('.panel.wd-desperado'));
				}
			});
			$document.on('change', ".wd-desperado select[id^='desperado-townOfOrigin-']", function (e) {
				if (window.$registry) {
					window.$registry.checkIsepLoadButtonEnabled($(this).closest('.panel.wd-desperado'));
				}
			});

		}
	}
}

if (!window.$wdEventCommon) {
	window.$wdEventCommon = new WdEventCommon();
}
